// SUPABASE CONNECTION
//
// These two values are deliberately in the source, not in environment
// variables.
//
// They are public by design. Create React App bakes any REACT_APP_ variable
// straight into the JavaScript bundle, so a value in Vercel and a value in
// this file end up in exactly the same place — visible to anyone who opens
// DevTools. There is no security difference, only an extra build-time step
// that can silently fail.
//
// What actually protects the data is Row Level Security. See
// supabase/leads.sql: anonymous visitors may INSERT a lead and nothing else.
// No select policy for `anon` means the customer list cannot be read with this
// key, whoever has it.
//
// The one key that must NEVER appear here is the service_role / secret key.
// That one bypasses RLS entirely.
//
// To change project or rotate the key: edit below, commit, push.

export const SUPABASE_URL = 'https://ofrhwxisubqezdbkaxyi.supabase.co';

export const SUPABASE_ANON_KEY = 'sb_publishable_oYnVa6AyaOznICtRlGm_Hg_3TjfHRJA';

// Table the website writes leads to.
export const LEADS_TABLE = 'leads';